export enum SearchResultsExecutionStatusEnums {
  NONSENSE = 'NONSENSE',
  ALT_BRAND = 'ALT_BRAND', // alternative brand scenario
  ALT_QUERIES = 'ALT_QUERIES', // may be meant scenario
  ALT_SPELL_UNCHANGED = 'ALT_SPELL_UNCHANGED', // may be like scenario
  ALT_SPELL_CHANGED = 'ALT_SPELL_CHANGED',
  DEFAULT = 'DEFAULT',
}
